import React, { useState, useEffect, useMemo } from "react";
import { FiCalendar } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import CustomCalendar from './CustomCalendar'
import CreateMatchModal from './CreateMatchModal'
import moment from 'moment'
import useComponentVisible from '../utilities/useComponentVisible';
import Loader from "react-loader-spinner";
import { BASE_URL } from "../constants/config";
import { useDispatch, useSelector } from "react-redux";
import {fetchAllMatches, updateManyMatches} from '../actions/matches'
import {fetchAllStadiums} from '../actions/stadiumsActions'
import {fetchAllReferees} from '../actions/judjesActions'
import SearchSelect from './SearchSelect'
import {fetchAllAdminLeagues} from '../actions/leaguesActions'
import {API_URLS} from '../constants/config'
import defaultTeamLogo from "../images/defaultTeamLogo.png";
import SelectSearch from 'react-select-search';
import Fuse from 'fuse.js';

export default function MatchCenter(props) {
  const history = useHistory();
  const [isCreateMatchModalOpen, setIsCreateMatchModalOpen] = useState(false);

  // Быстрое редактирование: строки не ведут в матч, а превращаются в поля.
  // Справочники судей и стадионов грузим только при входе в режим — на
  // обычном просмотре они не нужны и замедляли бы открытие матч-центра
  const [quickEdit, setQuickEdit] = useState(false);
  const [quickEdits, setQuickEdits] = useState({});
  const [quickSaving, setQuickSaving] = useState(false);
  const [quickError, setQuickError] = useState(null);
  const [stadiumsList, setStadiumsList] = useState([]);
  const [refereesList, setRefereesList] = useState([]);

  // Варианты для поиска в быстром редактировании
  const stadiumOptions = useMemo(
    () => stadiumsList.map(one => ({ value: one.id, label: one.name || `Стадион #${one.id}` })),
    [stadiumsList]
  );
  const refereeOptions = useMemo(
    () => refereesList.map(one => ({
      value: one.id,
      label: `${one.family || ''} ${one.name || ''}`.trim() || `Судья #${one.id}`,
    })),
    [refereesList]
  );
  const [refsLoading, setRefsLoading] = useState(false);
  // Читаем параметры из URL
  const urlParams = new URLSearchParams(window.location.search);
  const savedDate = urlParams.get('date');
  const [currentDate, setcurrentDate] = useState(() => {
    return savedDate ? moment(savedDate) : moment(new Date());
  });
  const [championships, setChampionships] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [allLeagues, setAllLeagues] = useState([]);
  const [selectedChampionship, setSelectedChampionship] = useState(-2);
  const [selectedLeague, setSelectedLeague] = useState(-2);
  const [isRestoringState, setIsRestoringState] = useState(true);
  const {
    ref,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);
  const matches = useSelector(state => state.matches.matchesData.data);
  const loading = useSelector(state => state.matches.loading);
  const dispatch = useDispatch();
  const isMountedRef = React.useRef(true);

  useEffect(() => {
    _loadAsyncAdminLeagues()
    
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  
  // Отдельный useEffect для загрузки матчей после загрузки лиг
  useEffect(() => {
    if (allLeagues.length > 0 && isRestoringState) {
      // Читаем параметры из URL
      const urlParams = new URLSearchParams(window.location.search);
      const savedChampionship = urlParams.get('championship');
      const savedLeague = urlParams.get('league');
      
      // Восстанавливаем состояние фильтров при возврате
      if (savedChampionship && savedChampionship !== '-2') {
        const filtered = allLeagues.filter(l => l.championat_name === savedChampionship);
        setLeagues(filtered);
        setSelectedChampionship(savedChampionship);
      }
      
      let leagueToLoad = -2;
      if (savedLeague && savedLeague !== '-2') {
        const numericLeagueId = parseInt(savedLeague);
        setSelectedLeague(numericLeagueId);
        leagueToLoad = numericLeagueId;
      }
      
      _loadAsyncMatches(currentDate, leagueToLoad);
      setIsRestoringState(false);
    }
  }, [allLeagues]);

  const _loadAsyncAdminLeagues = () => {
    dispatch(fetchAllAdminLeagues()).then(
      leagues => {
        if (!isMountedRef.current) return;
        
        if (leagues && leagues.data) {
          // Сохраняем все лиги
          const temp_all_leagues = leagues.data.map((item, index) => {
            item.value = item.league_id;
            item.key = index;
            item.name = item.league_name;
            return item;
          });
          setAllLeagues(temp_all_leagues);
          
          // Извлекаем уникальные чемпионаты
          const championshipsMap = new Map();
          leagues.data.forEach(item => {
            if (item.championat_name && !championshipsMap.has(item.championat_name)) {
              championshipsMap.set(item.championat_name, {
                value: item.championat_name,
                name: item.championat_name,
                client_id: item.client_id
              });
            }
          });
          
          const temp_championships = Array.from(championshipsMap.values());
          setChampionships(temp_championships);
        }
      }
    ).catch(error => {
      if (!isMountedRef.current) return;
      console.error('Error loading leagues:', error);
      setChampionships([]);
      setAllLeagues([]);
    });
  };



  const getDayNumber = () => {
    return currentDate.format('D')
  }

  const checkDateActive = (date) => {

    if(currentDate.isSame(date, 'day')){
      return 'matcheCenterMenuItemActive'
    } else {
      return ''
    }
  }

  const _loadAsyncMatches = (date, league_id = null) => {
    let url = API_URLS.getAllMatches;
    dispatch(fetchAllMatches(url, date.format('YYYY-MM-DD'), 'currentDate', 20, 0, league_id))
  }
  
  const updateURL = (date, championship, league) => {
    const params = new URLSearchParams();
    params.set('date', date.format('YYYY-MM-DD'));
    if (championship && championship !== -2) {
      params.set('championship', championship);
    }
    if (league && league !== -2) {
      params.set('league', league);
    }
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  }

  const fuzzySearch = (options) => {
    const fuse = new Fuse(options, {
      keys: ['name'],
      threshold: 0.3,
    });

    return (value) => {
      if (!value.length) {
        return options;
      }
      return fuse.search(value).map(item => item.item);
    };
  }

  const changeChampionship = (championship_name) => {
    setSelectedChampionship(championship_name);
    setSelectedLeague(-2);
    
    // Сохраняем в URL
    updateURL(currentDate, championship_name, -2);
    
    // Фильтруем лиги по выбранному чемпионату
    if (championship_name && championship_name !== -2) {
      const filtered = allLeagues.filter(l => l.championat_name === championship_name);
      setLeagues(filtered);
    } else {
      setLeagues([]);
    }
    
    // Загружаем матчи без фильтра по лиге
    _loadAsyncMatches(currentDate, -2);
  };

  const changeLeague = (league_id) => {
    const numericLeagueId = league_id === -2 || league_id === '-2' ? -2 : parseInt(league_id, 10);
    setSelectedLeague(numericLeagueId);
    
    // Сохраняем в URL
    updateURL(currentDate, selectedChampionship, numericLeagueId);
    
    _loadAsyncMatches(currentDate, numericLeagueId);
  }

  const getFilteredMatches = () => {
    if (!matches) return [];
    
    // Если лига не выбрана, показываем все матчи
    if (!selectedLeague || selectedLeague === -2) {
      return matches;
    }
    
    // Фильтруем матчи по выбранной лиге
    return matches.filter(match => match.league_id === selectedLeague);
  }

  const rendeTeamImage = (image) => {
    if(!image || (image && image == '') || (image && image == '/images/others/defaultLogo.png')){
      return (
        <img src={defaultTeamLogo} className="teamImage"/>  
      )
    } else {
      return (
        <img src={BASE_URL.url + image} className="teamImage"/>  
      )
    }
  }

  const checkCalendarSwitch = () => {
    if(checkDateActive(moment().subtract(1, 'days')) === '' 
    && checkDateActive(moment()) === '' && checkDateActive(moment().add(1, 'days')) === '' ){
      return 'matcheCenterCalendarActive';
    } else {
      return '';
    }
  }

  const openCalendar = () => {
    setIsComponentVisible(!isComponentVisible)
  }

  const handleCreateMatchSuccess = () => {
    // Перезагружаем матчи после создания
    _loadAsyncMatches(currentDate, selectedLeague);
  };

  const changeDate = (date) => {
    setIsComponentVisible(false)
    setcurrentDate(date)
    
    // Сохраняем в URL
    updateURL(date, selectedChampionship, selectedLeague);
    
    _loadAsyncMatches(date, selectedLeague)
  }

  const getMatchState = (data) => {
    if(data.resheduled){
      return 'Матч перенесен';
    } else {
      if (data.status) {
        if(data.status == 5){
          return 'ТП';
        }else if(data.status == 3){
          return 'Перерыв';
        }else if(data.status == 2) {
          return 'Матч окончен';
        }else if (data.status === 0 && !data.second_time_start) {
          return 'Матч не начался';
        } else if (data.status === 0 && data.second_time_start) {
          return 'Перерыв';
        } else if (!data.second_time_start) {
          if(data.status == 1){
            return 'Идет 1-ый тайм';
          } else if(data.status == 4){
            return 'Доп. время. Идет 1-ый тайм';
          }
        } else if (data.second_time_start) {
          if(data.status == 1){
            return 'Идет 2-ый тайм';
          } else if(data.status == 4){
            return 'Доп. время. Идет 2-ый тайм';
          }
        } else {
          return 'Матч окончен';
        }
      } else {
        if (!data.second_time_start) {
          return 'Матч не начался';
        } else {
          return 'Перерыв';
        }
      }
    }

  };

  const renderMatchScore = (item) => {
    if(item.status){
      if(item.status === 0 && !item.second_time_start){
        return (
          <div className="matchResult">
          -:- 
       </div>
        )
      } else {
        return (
          <div className="matchResult">
          {item.home_team_scores}:{item.guest_team_scores}
        </div>
        )
      }
    } else {
      if (!item.second_time_start) {
        return (
          <div className="matchResult">
          -:- 
       </div>
        )
      } else {
        return (
          <div className="matchResult">
          {item.home_team_scores}:{item.guest_team_scores}
        </div>
        )
      }
    }

  }



  const Calendar = React.forwardRef((props, ref) => {
    return <div className={`matchCenterCalendarWrapper`} ref={ref}><CustomCalendar {...props} currentDate={currentDate.toDate()} 
    changeDate={(e) => changeDate(moment(e))}/></div>
  })

  // Справочники нужны только в режиме правки — грузим по нажатию кнопки
  const enterQuickEdit = async () => {
    setQuickEdit(true);
    setQuickEdits({});
    setQuickError(null);
    if (stadiumsList.length && refereesList.length) return;
    setRefsLoading(true);
    try {
      const [stadiumsRes, refereesRes] = await Promise.all([
        dispatch(fetchAllStadiums(API_URLS.getAllStadiums)),
        dispatch(fetchAllReferees(API_URLS.getAllReferees)),
      ]);
      const stadiumRows = (stadiumsRes && (stadiumsRes.data || stadiumsRes)) || [];
      const refereeRows = (refereesRes && (refereesRes.data || refereesRes)) || [];
      setStadiumsList(Array.isArray(stadiumRows) ? stadiumRows : []);
      setRefereesList(Array.isArray(refereeRows) ? refereeRows : []);
    } catch (e) {
      console.error('Не удалось загрузить судей и стадионы:', e);
      setQuickError('Не удалось загрузить судей и стадионы');
    } finally {
      setRefsLoading(false);
    }
  };

  const cancelQuickEdit = () => {
    setQuickEdit(false);
    setQuickEdits({});
    setQuickError(null);
  };

  const editValue = (item, field) => {
    const patch = quickEdits[item.id];
    if (patch && patch[field] !== undefined) return patch[field];
    if (field === 'date') return item.date ? String(item.date).slice(0, 10) : '';
    if (field === 'time') return item.time ? String(item.time).slice(0, 5) : '';
    if (field === 'stadium_id') return item.stadium_id || '';
    if (field === 'judje_id') return item.judje_id || '';
    return '';
  };

  const setEditValue = (matchId, field, value) => {
    setQuickEdits(prev => ({
      ...prev,
      [matchId]: { ...(prev[matchId] || {}), [field]: value },
    }));
  };

  // Частичное обновление одним запросом: меняются только переданные поля
  const saveQuickEdits = async () => {
    const ids = Object.keys(quickEdits);
    if (ids.length === 0) {
      cancelQuickEdit();
      return;
    }
    setQuickSaving(true);
    setQuickError(null);
    try {
      const matches = ids.map(id => {
        const patch = quickEdits[id];
        const row = { match_id: Number(id) };
        if (patch.date !== undefined) row.date = patch.date || null;
        if (patch.time !== undefined) {
          row.time = patch.time ? `${patch.time}:00` : null;
        }
        if (patch.stadium_id !== undefined) {
          row.stadium_id = patch.stadium_id === '' ? null : Number(patch.stadium_id);
        }
        if (patch.judje_id !== undefined) {
          row.judje_id = patch.judje_id === '' ? null : Number(patch.judje_id);
        }
        return row;
      });
      const result = await dispatch(updateManyMatches(matches));
      const failed = (result && result.failed) || [];
      if (failed.length) {
        const idsFailed = failed.map(f => f.match_id || f).join(', ');
        setQuickError(`Не сохранились матчи: ${failed.length}${idsFailed ? ` (${idsFailed})` : ''}. Остальные обновлены.`);
        _loadAsyncMatches(currentDate, selectedLeague);
        return;
      }
      cancelQuickEdit();
      _loadAsyncMatches(currentDate, selectedLeague);
    } catch (e) {
      console.error('Не удалось сохранить быстрые правки', e);
      setQuickError('Не удалось сохранить изменения.');
    } finally {
      setQuickSaving(false);
    }
  };

  const renderMatches = () => {
    const filteredMatches = getFilteredMatches();
    return filteredMatches.map((item, index) => {
      return (
        <tr
          onClick={quickEdit ? undefined : ()=>props.goToMatchResult(item.id)}
          className={quickEdit ? 'matchCenterRow matchCenterRowEditing' : 'matchCenterRow'}
          key={index}>
        <td className="matchTableTime">
          {quickEdit ? (
            <div className="quickEditCell">
              <input
                type="date"
                className="quickEditInput"
                value={editValue(item, 'date')}
                onChange={(e) => setEditValue(item.id, 'date', e.target.value)}
              />
              <input
                type="time"
                className="quickEditInput"
                value={editValue(item, 'time')}
                onChange={(e) => setEditValue(item.id, 'time', e.target.value)}
              />
            </div>
          ) : (
            item.time ? item.time.substring(item.time.length - 3, 0) : '—'
          )}
        </td>
        <td className="matchTableMatch">
          <div className="oneMatchTeamsWrapper">
            <div className="teamWrapper">
              <div className="teamName">{item.home_team_name}</div>
              {rendeTeamImage(item.home_team_image)}   
            </div>
              {renderMatchScore(item)}
            <div className="teamWrapper" style={{justifyContent:'flex-start'}}>
              {rendeTeamImage(item.guest_team_image)}   
              <div className="teamName">{item.guest_team_name}</div>  
            </div>
          </div>
        </td>
        <td className="matchTableStadium">
          {quickEdit ? (
            <SearchSelect
              value={editValue(item, 'stadium_id')}
              options={stadiumOptions}
              emptyLabel="Стадион не выбран"
              placeholder="Название стадиона"
              onChange={(value) => setEditValue(item.id, 'stadium_id', value)}
            />
          ) : item.stadium_name}
        </td>
        <td className="matchTableStatus">
          {quickEdit ? (
            <SearchSelect
              value={editValue(item, 'judje_id')}
              options={refereeOptions}
              emptyLabel="Судья не назначен"
              placeholder="Фамилия судьи"
              onChange={(value) => setEditValue(item.id, 'judje_id', value)}
            />
          ) : getMatchState(item)}
        </td>
        </tr>
      )
    })
  }

  const renderContent = () => {
    if(!loading){
      const filteredMatches = getFilteredMatches();
      if(filteredMatches && filteredMatches.length > 0){
        return (
          <div className="tableWrapper">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th className="matchTableTime">Время</th>
                    <th className="matchTableMatch">Матч</th>
                    <th className="matchTableStadium">Стадион</th>
                    <th className="matchTableStatus">Статус</th>
                  </tr>
                </thead>
                <tbody>
                  {renderMatches()}
                </tbody>
              </table>
            </div>
          </div>
        )
      } else {
        return (
          <div className="emptyWrapper">
            <span className="emptyText">Похоже в это день матчей нет...</span>
          </div>
        )
      }
    } else {

      return (
        <div className="loadingOverlay">
          <div className="loadingWrapper">
            <Loader
              type="Rings"
              color="#04a9f5"
              height={40}
              width={40}
              timeout={0}/>
            <span style={{marginLeft:10}}>Загрузка матчей</span>
          </div>
        </div>
      )
    }
  }

  return (
    <div className="matchCenterWrapper">
      <div className="matchCenterHeader">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', paddingRight: '50px' }}>
          <span className="matchCenterName">Матч-Центр</span>
          <button
            onClick={() => setIsCreateMatchModalOpen(true)}
            style={{
              padding: '10px 24px',
              background: 'linear-gradient(135deg, #04a9f5 0%, #0288d1 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              boxShadow: '0 2px 8px rgba(4, 169, 245, 0.3)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 12px rgba(4, 169, 245, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 8px rgba(4, 169, 245, 0.3)';
            }}
          >
            + Создать матч
          </button>

          {quickEdit ? (
            <div className="quickEditActions">
              <button
                className="quickEditBtn quickEditBtnGhost"
                disabled={quickSaving}
                onClick={cancelQuickEdit}
              >
                Отмена
              </button>
              <button
                className="quickEditBtn quickEditBtnPrimary"
                disabled={quickSaving}
                onClick={saveQuickEdits}
              >
                {quickSaving ? 'Сохраняем...' : 'Сохранить'}
              </button>
            </div>
          ) : (
            <button className="quickEditBtn quickEditBtnGhost" onClick={enterQuickEdit}>
              Быстрое редактирование
            </button>
          )}
        </div>

        {quickEdit ? (
          <div className="quickEditNote">
            {refsLoading
              ? 'Загружаем судей и стадионы...'
              : 'Строки не открываются — правьте дату, время, стадион и судью прямо здесь, затем нажмите «Сохранить».'}
            {quickError ? <span className="quickEditError"> {quickError}</span> : null}
          </div>
        ) : null}
        <div style={{display: 'flex', gap: '20px', marginTop: '10px', marginBottom: '10px', alignItems: 'center', flexWrap: 'wrap'}}>
          <div style={{display: 'flex', flexDirection: 'column', minWidth: '300px', flex: '1', maxWidth: '400px'}}>
            <span className="matchAdditionalInfoSelectHeading">Чемпионат</span>
            <SelectSearch
              options={championships}
              search
              value={selectedChampionship}
              filterOptions={fuzzySearch}
              onChange={(x) => changeChampionship(x)}
              emptyMessage="Чемпионат не найден"
              placeholder="Выберите чемпионат"/>  
          </div>
          
          {selectedChampionship && selectedChampionship !== -2 && (
            <div style={{display: 'flex', flexDirection: 'column', minWidth: '250px', flex: '1', maxWidth: '350px'}}>
              <span className="matchAdditionalInfoSelectHeading">Лига</span>
              <SelectSearch
                options={leagues}
                search
                value={selectedLeague}
                filterOptions={fuzzySearch}
                onChange={(x) => changeLeague(x)}
                emptyMessage="Лига не найдена"
                placeholder="Выберите лигу"/>  
            </div>
          )}
        </div>
        <div className="dateWrapper">
          <div className={`calendarIconWrapper ${checkCalendarSwitch()}`} onClick={openCalendar}>
            {/* <img src={calendar} className="calendarIcon"/> */}
            <FiCalendar size="30px"/>
            <span className="dateNumber">{getDayNumber()}</span>
          </div>
          <span onClick={()=>changeDate(moment().subtract(1, 'days'))} className={`matcheCenterMenuItem ${checkDateActive(moment().subtract(1, 'days'))}`}>Вчера</span>
          <span onClick={()=>changeDate(moment())} className={`matcheCenterMenuItem ${checkDateActive(moment())}`}>Сегодня</span>
          <span onClick={()=>changeDate(moment().add(1, 'days'))} className={`matcheCenterMenuItem ${checkDateActive(moment().add(1, 'days'))}`}>Завтра</span>
        </div>
      </div>
      {
        isComponentVisible && 
        <Calendar 
          ref={ref} />
      }
      {renderContent()}
      
      {/* Модальное окно создания матча */}
      <CreateMatchModal 
        isOpen={isCreateMatchModalOpen}
        onClose={() => setIsCreateMatchModalOpen(false)}
        onSuccess={handleCreateMatchSuccess}
      />
    </div>
  );
}
